import { SettlementsService } from 'src/app/services/settlements.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-payment',
  template: `
    <div class="row">
      <div class="col-sm-11 offset-sm-1 col-md-11 offset-md-1 col-lg-8 offset-lg-4 col-xl-9 offset-xl-3 mt-5">
        <div class="row mb-4">
          <div class="col-md-5">
            <h1>Realizar Pago</h1>
            <!-- p>Consulta a los inquilinos y la estructura de los condominios.</!-->
          </div>
          <!-- div class="col-md-7 mt-4 text-end">
            <button class="btn btn-primary btn-lg rounded-5" routerLink="/payments/receipts">Generar recibos</button>
            <button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</button>
          </!-->
        </div>
        <div class="card border-0 rounded-4">
          <div class="card-body p-4">        
            <form [formGroup]="payForm" (ngSubmit)="onSubmit(payForm)">
              <div class="row">
                <div class="col-md-8">
                  <h2>Datos del usuario</h2>
                  <div class="form-group mt-3">
                    <label for="first_name">Nombre(s)</label>
                    <input type="text" class="form-control" formControlName="first_name" id="first_name" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="last_name">Apellidos</label>
                    <input type="text" class="form-control" formControlName="last_name" id="last_name" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="birth_date">Fecha de nacimiento</label>
                    <input type="text" class="form-control" formControlName="birth_date" id="birth_date" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="email">Correo electrónico</label>
                    <input type="text" class="form-control" formControlName="email" id="email" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="phone">Teléfono</label>
                    <input type="text" class="form-control" formControlName="phone" id="phone" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <!-- div class="form-group mt-3">
                    <label for="country">País</label>
                    <input type="text" class="form-control" formControlName="country" id="country" aria-describedby="emailHelp" placeholder="Nombre">
                  </!-->
                  <h2>Dirección</h2>
                  <div class="form-group">
                    <label for="address">Calle</label>
                    <input type="text" class="form-control" formControlName="address" id="address" aria-describedby="direccionHelp" placeholder="Dirección">
                  </div>
                  <div class="form-group mt-3">
                    <label for="city">Ciudad</label>
                    <input type="text" class="form-control" formControlName="city" id="city" aria-describedby="cityHelp" placeholder="Ciudad">
                  </div>
                  <div class="form-group mt-3">
                    <label for="state">Estado</label>
                    <select class="form-select" >
                      <option value="">Selecciona un estado</option>
                      <option *ngFor="let state of edos" [value]="state.value">{{state.name}}</option>
                    </select>
                    <!-- input type="text" class="form-control" formControlName="state" id="state" aria-describedby="emailHelp" placeholder="Nombre" -->
                  </div>
                  <div class="form-group">
                    <label for="zip_code">Código postal</label>
                    <input type="text" class="form-control" formControlName="zip_code" id="zip_code" aria-describedby="zipCodeHelp" placeholder="Código postal">
                  </div>

                </div>
                <div class="col-md-4">
                  <div class="form-group mt-3">
                    <label for="transaction_id">Transacción #</label>
                    <input type="text" class="form-control" formControlName="transaction_id" id="transaction_id" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="amount">Cantidad</label>
                    <input type="text" class="form-control" formControlName="amount" id="amount" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group mt-3">
                    <label for="description">Descripción</label>
                    <input type="text" class="form-control" formControlName="description" id="description" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group">
                    <label for="card_number">Número en la tarjeta</label>
                    <input type="number" class="form-control" formControlName="card_number" id="card_number" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>

                  <div class="form-group">
                    <label for="name_on_card">Nombre que aparece en la tarjeta</label>
                    <input type="text" class="form-control text-uppercase" formControlName="name_on_card" id="name_on_card" aria-describedby="emailHelp">
                  </div>
                  <div class="form-group">
                    <label for="expiration_year">Año</label>
                    <input type="text" class="form-control" formControlName="expiration_year" id="expiration_year" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group">
                    <label for="expiration_month">Mes</label>
                    <input type="text" class="form-control" formControlName="expiration_month" id="expiration_month" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                  <div class="form-group">
                    <label for="cvv">CVV</label>
                    <input type="text" class="form-control" formControlName="cvv" id="cvv" aria-describedby="emailHelp" placeholder="Nombre">
                  </div>
                </div>
                <div class="col-md-12">
                  <button type="submit" class="btn btn-primary btn-lg rounded-5">Realizar pago</button>
                </div>
              </div>
            </form>          
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class PaymentComponent {
  bill: any = {};
  profile: any = {};
  payForm: FormGroup = new FormGroup({});

  edos: any[] = [
    { "name": "Aguascalientes", "value": "AG" },
    { "name": "Baja California", "value": "BC" },
    { "name": "Baja California Sur", "value": "BS" },
    { "name": "Campeche", "value": "CM" },
    { "name": "Chiapas", "value": "CS" },
    { "name": "Chihuahua", "value": "CH" },
    { "name": "Ciudad de México", "value": "CX" },
    { "name": "Coahuila", "value": "CO" },
    { "name": "Colima", "value": "CL" },
    { "name": "Durango", "value": "DG" },
    { "name": "Guanajuato", "value": "GT" },
    { "name": "Estado de Guerrero", "value": "GR" },
    { "name": "Estado de Hidalgo", "value": "HG" },
    { "name": "Jalisco", "value": "JC" },
    { "name": "Estado de México", "value": "EM" },
    { "name": "Michoacán", "value": "MI" },
    { "name": "Morelos", "value": "MO" },
    { "name": "Nayarit", "value": "NA" },
    { "name": "Nuevo León", "value": "NL" },
    { "name": "Oaxaca", "value": "OA" },
    { "name": "Puebla", "value": "PU" },
    { "name": "Querétaro Arteaga", "value": "QT" },
    { "name": "Quintana Roo", "value": "QR" },
    { "name": "San Luis Potosí", "value": "SL" },
    { "name": "Sinaloa", "value": "SI" },
    { "name": "Sonora", "value": "SO" },
    { "name": "Tabasco", "value": "TB" },
    { "name": "Tamaulipas", "value": "TM" },
    { "name": "Tlaxcala", "value": "TL" },
    { "name": "Veracruz", "value": "VE" },
    { "name": "Estado de Yucatán", "value": "YU" },
    { "name": "Zacatecas", "value": "ZA "}
  ];
  storageService = inject(StorageService);
  constructor(
    private route: Router,
    private fb: FormBuilder,
    private settlementsService: SettlementsService,
    private paymentsService: PaymentsService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ?? {};
    // this.payload.utility_id = this.profile.profile ? this.profile.profile.utility_id : 0;
  }

  ngOnInit(): void {
    this.buildForm();
    console.log(this.route.url.split('/')[3]);
    this.settlementsService.getBill(this.route.url.split('/')[3]).subscribe({
      next: (res: any) => {
        this.bill = res;
        console.log(res);
        this.payForm.patchValue({
          transaction_id: res.id,
          amount: res.total,
          description: res.description,
        });
      }
    });    
  }

  buildForm() {
    this.payForm = this.fb.group({
      transaction_id: ['', Validators.required],
      amount: ['', Validators.required],
      description: ['', Validators.required],
      first_name: [''],
      last_name: [''],
      birth_date: [''],
      email: [''],
      phone: [''],
      country: [''],
      state: [''],
      city: [''],
      address: [''],
      zip_code: [''],
      name_on_card: [''],
      card_number: [''],
      expiration_year: [''],
      expiration_month: [''],
      cvv: [''],
      
    });
  }

  onSubmit(pay: any) {
    console.log(pay);

    const payload: any = {
      transaction_id: this.payForm.get('transaction_id')?.value,
      amount: this.payForm.get('amount')?.value,
      currency_code: "MXN",
      description: this.payForm.get('description')?.value,
      process_token: "2xUhFSsrYF5prDqA",
      customer_username: "JPERALTA",
      first_name: this.payForm.get('first_name')?.value,
      last_name: this.payForm.get('last_name')?.value,
      birth_date: this.payForm.get('birth_date')?.value,
      email: this.payForm.get('email')?.value,
      phone: this.payForm.get('phone')?.value,
      country: "MX",
      state: "CX",
      city: this.payForm.get('city')?.value,
      address: this.payForm.get('address')?.value,
      zip_code: this.payForm.get('zip_code')?.value,
      ip_address: "201.207.239.230",
      name_on_card: this.payForm.get('name_on_card')?.value,
      card_number: this.payForm.get('card_number')?.value,
      expiration_year: this.payForm.get('expiration_year')?.value,
      expiration_month: this.payForm.get('expiration_month')?.value,
      cvv: this.payForm.get('cvv')?.value,
      vip_level: 0
    };

    console.log(payload);
    this.paymentsService.createPayment(payload).subscribe({
      next: (res: any) => {
        console.log('CALLBAKC');
        console.log(res);
        window.location.href = res.redirect_url;
      },
      error: (err: any) => {
        console.log('ERROR');
        console.log(err);
      }
    });
  }

  // currency_code: ['', Validators.required],
  // process_token: ['', Validators.required],

}

// "transaction_id": "2210061347",
// "amount": 192.54,
// "currency_code": "MXN",
// "description": "Purchase# 2209131353",
// "process_token": "2xUhFSsrYF5prDqA",
// "customer_username": "JPERALTA",
// "ip_address": "201.207.239.230",    
// "vip_level": 0